<template>
  <div class="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu">
    <div class="layout-container" v-if="loggedIn">
      <!-- Navbar -->
      <nav style="position: inherit" class="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme" id="layout-navbar">
        <div class="container-xxl">
          <div class="navbar-brand app-brand demo d-none d-xl-flex py-0 me-4">

            <router-link class="app-brand-link" to="/">
              <img  class="app-brand-logo demo" width="190" alt="Logo de Sofofa Gris" src="../assets/logo_sofofa_gris.png"/>
            </router-link>

            <a href="javascript:void(0);" class="layout-menu-toggle menu-link d-xl-none text-large ms-auto">
              <i class="bx bx-chevron-left bx-sm align-middle"></i>
            </a>
          </div>

          <div class="layout-menu-toggle navbar-nav d-xl-none align-items-xl-center me-3 me-xl-0">
            <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
              <i class="bx bx-menu bx-sm"></i>
            </a>
          </div>

          <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
            <ul class="navbar-nav flex-row align-items-center ms-auto">
              <!-- User -->
              <li class="nav-item navbar-dropdown dropdown-user dropdown">
                <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                  <div class="avatar avatar-online">
                    <img src="../assets/img/avatars/1.png" alt class="w-px-40 h-auto rounded-circle" />
                  </div>
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="dropdown-item" href="#">
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar avatar-online">
                            <img src="../assets/img/avatars/1.png" alt class="w-px-40 h-auto rounded-circle" />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <span class="d-block fw-semibold">{{currentUser.name}}</span>
                          <small class="text-muted">{{currentUser.role.name}}</small>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <div class="dropdown-divider"></div>
                  </li>
                  <li>
                    <router-link to="/profile" class="dropdown-item" href="#">
                      <i class="bx bx-user me-2"></i>
                      <span class="align-middle">Mi Perfil</span>
                    </router-link>
                  </li>
                  <li>
                    <div class="dropdown-divider"></div>
                  </li>
                  <li>
                    <button v-on:click="logout" class="dropdown-item" href="#">
                      <i class="bx bx-power-off me-2"></i>
                      <span class="align-middle">Salir</span>
                    </button>
                  </li>
                </ul>
              </li>
              <!--/ User -->
            </ul>
          </div>
        </div>
      </nav>
      <!-- / Navbar -->
        <!-- Content wrapper -->
      <div class="layout-page">

        <div class="content-wrapper">


          <!-- Content -->
          <slot />
          <!-- / Content -->

          <!-- Footer -->
          <footer class="content-footer footer bg-footer-theme">
            <div class="container-xxl d-flex flex-column flex-md-row flex-wrap justify-content-between py-2">
              <div class="mb-2 mb-md-0">
                ©
                2022
                , hecho️ por
                <a href="https://muss.cl" target="_blank" class="footer-link fw-bolder">Muss SPA</a>
              </div>
            </div>
          </footer>
          <!-- / Footer -->

          <div class="content-backdrop fade"></div>
        </div>
        <!-- Content wrapper -->
      </div>
    </div>

    <!-- Overlay -->
    <div class="layout-overlay layout-menu-toggle"></div>

    <!-- Drag Target Area To SlideIn Menu On Small Screens -->
    <div class="drag-target"></div>
  </div>
</template>
<script>
export default {
  name: 'AppLayoutPrivate',
  data : function () {
    return {
      menus: [
        {
          "id": 1,
          "name": "Dashboard",
          "to": "/",
          "icon": "menu-icon tf-icons bx bx-home-circle",
          "active": true,
        },
        {
          "id": 2,
          "name": "Empresas",
          "to": "/about",
          "icon": "menu-icon tf-icons bx bx-detail",
          "active": true,
        },
        {
          "id": 3,
          "name": "Usuarios",
          "to": "/users",
          "icon": "menu-icon tf-icons bx bx-user",
          "active": true,
        },
        {
          "id": 4,
          "name": "Dimensiones",
          "to": "/admin/dimensions",
          "icon": "menu-icon tf-icons bx bx-archive-in",
          "active": true,
        }
      ]
    }
  },
  props : [
    'uuid'
  ],
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  created() {
    if (!this.loggedIn) {
      this.$router.push("/auth/login");
    }
  },
  methods : {
    logout() {
      this.$store.dispatch("auth/logout").then(
          () => {
            this.$router.push("/auth/login");
          },
          (error) => {
            this.loading = false;
            this.message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
          }
      );
    }
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.spinner {
  margin: auto;
}

.vld-parent {
  position: relative;
}

#overlay {

  background-color: rgba(0,0,0,0.3);
  border: 0 solid #d9dee3;
  border-radius: 0.5rem;
  z-index: 2;
  cursor: pointer;
  min-height: 400px;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
